<template>
  <component :is="rootComponent" :class="rootClassName">
    <div class="summary-section" @click="toggle">
      <div class="summary max-w-full text-secondary select-none">
        <slot name="summary" />
      </div>
      <slot name="toggle">
        <div :class="summaryToggleClassName">
          <Icon
            :class="summaryToggleIconClassName"
            name="plus"
          />
        </div>
      </slot>
    </div>

    <div class="details" v-if="sourceOfTruthIsExpanded">
      <slot name="details" /><slot />
    </div>
  </component>
</template>

<script>

import Collapse from '../Collapse'
import Divider from '../Divider'
import Surface from '../Surface'
import defaultRootComponent from '../defaultRootComponent'

export default {
  name: 'ExpansionLine',

  inject: [ 'ExpansionPanelGroup' ],

  mixins: [ defaultRootComponent('div') ],

  components: {
    Collapse,
    Divider,
    Surface
  },

  props: {
    disabled: {
      type: Boolean
    },

    isExpanded: {
      type: Boolean,
      default: undefined
    },

    enclosed: {
      type: Boolean,
      default: true,
    },

    /* relevant only if the ExpansionPanel is part of a Group */
    name: {
      type: String
    }
  },

  data () {
    return {
      internalIsExpanded: false
    }
  },

  methods: {
    toggle (e) {
      if (this.uncontrolled) {
        this.toggleUncontrolled(e)
      } else {
        this.toggleControlled(e)
      }
    },

    toggleControlled (e) {
      if (this.ExpansionPanelGroup) {
        if (this.isExpanded) {
          this.ExpansionPanelGroup.expand(this.name)
        } else {
          this.ExpansionPanelGroup.expand(this.name)
        }
      } else {
        if (this.isExpanded) {
          this.$emit('close', e)
        } else {
          this.$emit('open', e)
        }
      }
    },

    toggleUncontrolled () {
      this.internalIsExpanded = !this.internalIsExpanded
    }
  },

  computed: {
    uncontrolled () {
      return !this.ExpansionPanelGroup && (this.isExpanded === undefined)
    },

    sourceOfTruthIsExpanded () {
      if (this.uncontrolled) {
        return this.internalIsExpanded
      } else {
        return this.ExpansionPanelGroup
          ? this.ExpansionPanelGroup.expanded === this.name
          : this.isExpanded
      }
    },

    rootComponent () {
      if (this.enclosed) { return 'div' }

      return this.component
    },

    rootClassName () {
      return [
        'root',
        {
          disabled: this.disabled,
          enclosed: this.enclosed
        },
        { 'summary-active': this.sourceOfTruthIsExpanded }
      ]
    },

    summaryToggleClassName () {
      return [ 'summary-toggle' ]
    },

    summaryToggleIconClassName () {
      return [
        'summary-toggle-icon',
        { 'summary-toggle-icon-active': this.sourceOfTruthIsExpanded }
      ]
    }
  }
}

</script>

<style scoped>

.root {}

.disabled {
  position: relative;
  pointer-events: none;
  border-color: rgba(0, 0, 0, 0.2);
}

.disabled::before {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
}

.summary-section {
  display: flex;
  cursor: pointer;
  @apply
    p-4;
}

.summary:hover,
.summary-active .summary {
  @apply
    text-primary;
}

.summary {
  flex-grow: 1;
}

.summary-toggle {
  display: flex;
  align-items: center;
}

.summary-toggle-icon {
  transition: 0.2s;
  @apply 
    text-primary;
}

.summary-toggle-icon-active {
  transform: rotate(135deg);
}

.details {
  overflow: hidden;
  @apply
    px-4
}

.enclosed > .details {
  @apply
    border-t-0
    border-b;
}

.enclosed > .summary-section {
  @apply
    border-0
    border-b
    border-solid
    border-dull;
}

</style>
